<template>
  <div v-if="showDialog">
    <VDialog v-model="showTransferDialog" max-width="500px" persistent>
      <VCard>
        <VCardTitle>
          <span >
            {{moment(lesson.schedule_date).format('YYYY/MM/DD(ddd)')}} {{lesson.time_limit_name}} {{lesson.start_time}}
          </span>
        </VCardTitle>
        <VCardText>
          <span style="text-align: left" class="showNewLine">
            {{lesson.classroom_name3}}
            {{'\n'}}
            {{lesson.class_type_label}} {{lesson.school_year_name3}} {{lesson.subject_name3}}{{lesson.course_name3}}
            {{'\n'}}
            <span
              class="showNewLine"
              :style="{ color: lesson.sex === 1 ? 'blue' : lesson.sex === 2 ? 'red' : null }"
            >
              {{lesson.student_name}}
            </span>
          </span>
        </VCardText>
        <VCardText>
          <VRow align="center">
            <VCol cols="auto">
              {{ $t('C40101.TransferDialog.Jyw20gVmwjMmitVUmFjc2') }}
            </VCol>
            <VCol class="letsCenterSelectWrapper">
              <VAutocomplete
                v-bind="{
                  ...PresetList(this).autoComplete.props
                }"
                v-model="lesson.center_no"
                :items="getM0110GroupCenter"
                disabled
              ></VAutocomplete>
            </VCol>
          </VRow>
        </VCardText>
        <VCardText>
          <VRow align="center">
            <VCol cols="auto">
              {{ $t('C40101.TransferDialog.bjC_BOVOhOl5xudo9jk8Y') }}
            </VCol>
            <VCol class="letsCenterSelectWrapper">
              <VAutocomplete
                v-bind="{
                  ...PresetList(this).autoComplete.props
                }"
                v-model="lesson._target_center_no"
                :items="getM0110GroupCenter.filter(item => item.value !== lesson.center_no)"
              ></VAutocomplete>
            </VCol>
          </VRow>

        </VCardText>
        <VCardActions>
          <VSpacer></VSpacer>
          <VBtn
            color="primary"
            :disabled="!lesson._target_center_no"
            @click="confirmTransfer"
          >
            OK
          </VBtn>
          <VBtn
            v-bind="{
              color: '#AEAEAE',
              style: { color: '#FFFFFF' }
            }"
            @click="showTransferDialog = false">
            {{ $t('common.cancel') }}
          </VBtn>
        </VCardActions>
        <div v-debug>{{lesson}}</div>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import { GridItem } from './gridLayoutUtils';
import moment from 'moment';
import ConfirmDialogPreset from '@/components/autoImport/ConfirmDialogPreset';
import { PresetList } from '@/components/base/atoms/AtForm/AtFormUtils';
export default {
  props: {
  },
  data() {
    return {
      showTransferDialog: false,
      showDialog: false,
      gridItem: new GridItem(),
      PresetList
    };
  },
  computed: {
    lesson() {
      return this.gridItem.data;
    },
    ...require('vuex').mapGetters("C40101", [
      "getM0110GroupCenter",
    ], ),
  },
  methods: {
    moment,
    ...require('vuex').mapActions("C40101", [
      "C40101_setTransfer",
      "C40101_removeTransfer"
    ],),
    async showSet(gridItem) {
      this.gridItem = gridItem;
      this.showDialog = true;
      const studentName = this.lesson.student_name;
      const proceed = await this.$confirm({
        ...ConfirmDialogPreset.baseConfirm(window.vue),
        text: this.$t('C40101.TransferDialog.iP-omXxl3ai6MBjVUgUo6', [studentName]),
      });
      if (!proceed) return;

      // Proceed with the transfer logic
      this.showTransferDialog = true;
    },
    async confirmTransfer(){
      this.showTransferDialog = false
      const result = await this.$parent.$refs.PasswordConfirmationDialog.showDialog({
        password: '',
        incorrect: false
      })
      if(!result) return
      await this.C40101_setTransfer({
        lesson: this.lesson,
        targetCenterNo: this.lesson._target_center_no,
      });
    },
    async showUnset(gridItem) {
      this.gridItem = gridItem;
      this.showDialog = true;
      const studentName = this.lesson.student_name;
      const proceed = await this.$confirm({
        ...ConfirmDialogPreset.baseConfirm(window.vue),
        text:this.$t('C40101.TransferDialog.ogTU3n8nI-MrHoRAxlYFz', [studentName]),
      });
      if (!proceed) return;
      await this.C40101_removeTransfer({
        lesson: this.lesson,
      });
    }
  },
};
</script>

<style>
</style>
